import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  onClick?: () => void;
  hoverable?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  onClick,
  hoverable = false
}: CardProps) {
  const baseStyles = 'bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden';
  const hoverStyles = hoverable ? 'hover:shadow-md hover:border-gray-300 transition-all cursor-pointer' : '';
  const paddingStyles = noPadding ? '' : 'p-6';
  if (hoverable) {
    return <motion.div whileHover={{
      y: -2
    }} className={`${baseStyles} ${hoverStyles} ${paddingStyles} ${className}`} onClick={onClick} data-id="element-85">
        {children}
      </motion.div>;
  }
  return <div className={`${baseStyles} ${paddingStyles} ${className}`} onClick={onClick} data-id="element-86">
      {children}
    </div>;
}